import { render } from "./UserWrapperComponent.vue?vue&type=template&id=3b81b6ce&ts=true"
import script from "./UserWrapperComponent.vue?vue&type=script&lang=ts"
export * from "./UserWrapperComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__